<router-outlet></router-outlet>
<div class="toast_display_layer">
  <p-toast></p-toast>
</div>
<!-- <ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="medium" color="#8c4abd" type="ball-climbing-dot" [fullScreen]="true">
    <p style="color: #8c4abd"> Your data is getting prepared... </p>
</ngx-spinner> -->

<ngx-spinner
  bdColor="rgba(0, 0, 0, 0.8)"
  size="medium"
  color="#8c4abd"
  type="square-jelly-box"
  [fullScreen]="true"
>
  <p style="color: #8c4abd">
    <img src="/assets/img/doqfy-load.gif" style="height: 120px" />
  </p>
  <p style="color: #ffffff">Your data is getting prepared...</p>
</ngx-spinner>
<app-upload-progress-popup></app-upload-progress-popup>
